const List = () => import(/* webpackChunkName: "cancelamento-adesao-bundle" */ './main.vue');

export default [
  {
    name: 'relatorio/cancelamento-adesao',
    path: '/relatorio/cancelamento-adesao',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Solicitação de Cancelamento do Plano',
      icon: 'user-slash',
      can: 'list',
      on: 'cancelamentoadesao',
    },
  },
];
